import React from 'react';
import { MapContainer, TileLayer, Marker, Polyline, Popup } from 'react-leaflet';
import L, { LatLngTuple } from 'leaflet';
import 'leaflet/dist/leaflet.css';

interface Location {
    lat: number;
    lng: number;
    timestamp: string;
    bearing: number;
}

interface MapComponentProps {
    locations: Location[];
}

const MapComponent: React.FC<MapComponentProps> = ({ locations }) => {
    if (locations.length === 0) {
        return <div>No locations available</div>;
    }

    const minLat = Math.min(...locations.map(loc => loc.lat));
    const maxLat = Math.max(...locations.map(loc => loc.lat));
    const minLng = Math.min(...locations.map(loc => loc.lng));
    const maxLng = Math.max(...locations.map(loc => loc.lng));

    const bounds: LatLngTuple[] = [
        [minLat, minLng], // Southwest corner
        [maxLat, maxLng]  // Northeast corner
    ];

    const imgBase64 = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAvUlEQVRoge3U0QqCMBiGYeuw6CwYO9wG8wLqUoMOupcQurDawIGIyFzMTXkf+EFE8fucrmkAAAAAADskhDj7KZ0jiZTypJR6a60/bdteSudZZBD+2892SkyE304J/727oF0I7Yo8/QxKdNX+ExNv/uVOH90c3PGj6pWYCR/UWyIifFBfiQXhg3pKJIQPypcY7zb98d0Yc4sZf+34/tV2p5l9/t/JvxIZw69Twlp7jf1MUsc/I1sBAAAAALvyA+HZtO1rZkA7AAAAAElFTkSuQmCC';

    const createIcon = (bearing: number) => {
        return L.divIcon({
            html: `<div style="transform: rotate(${bearing}deg);"><img src="${imgBase64}" alt="marker" /></div>`,
            className: 'bearing-marker',
            iconSize: [30, 30],
            iconAnchor: [15, 15],
        });
    };

    return (
        <MapContainer bounds={bounds} style={{ height: '100vh', width: '100%' }}>
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            {locations.map((location, index) => (
                <Marker key={index} position={[location.lat, location.lng]} icon={createIcon(location.bearing)}>
                    <Popup>
                        {new Date(location.timestamp).toLocaleTimeString()}
                        <br/>
                        ({location.lat}, {location.lng})
                    </Popup>
                </Marker>
            ))}
            <Polyline positions={locations.map(loc => [loc.lat, loc.lng])} />
        </MapContainer>
    );
};

export default MapComponent;